import { useMutation, UseMutationResult, useQueryClient } from 'react-query';

import { getTokenWithType } from './useAuth';

import { questionDetailItem as deleteQuestion } from '../utils/urls';

import { ErrorModal } from 'types/modalTypes';

async function deleteQuestions({
  questionTemplateId,
}: TVariables): Promise<TResult> {
  const response = await fetch(deleteQuestion(questionTemplateId), {
    method: 'DELETE',
    headers: {
      Authorization: getTokenWithType(),
      'Content-Type': 'application/json',
    },
  });
  return new Promise((resolve, reject) => {
    if (response.status === 200) resolve(true);
    else reject(false);
  });
}

type TError = ErrorModal;

type TResult = boolean;

type TVariables = {
  questionTemplateId: number;
};
type TSnapshot = unknown;

function useDeleteQuestions(): UseMutationResult<
  TResult,
  TError,
  number,
  TSnapshot
> {
  const queryClient = useQueryClient();
  return useMutation(async (questionTemplateId: number) => {
    const deleteQuestionResult = await deleteQuestions({
      questionTemplateId,
    });
    queryClient.invalidateQueries(['questions_list'], {
      refetchInactive: true,
    });
    return deleteQuestionResult;
  });
}

export { useDeleteQuestions };
